<div class="flex flex-col gap-y-2">
  @let vm = offshoreReportStore.vm();
  @if (vm.isSectionVisible('bunker', 'fuelOilBunkerTable')) {
    <re-fuel-oil-bunker-table id="bunkerTable" />
    <p-divider />
  }

  @if (offshoreBunkerStore.dynamicSection()) {
    <re-dynamic-form
      tabId="bunker"
      [events]="events"
      [formConfig]="
        offshoreReportStore.formConfig()?.tabs?.['bunker']?.customFields ?? []
      "
      [storeSectionState]="offshoreBunkerStore.dynamicSection()"
      class="flex flex-col gap-y-2"
    ></re-dynamic-form>
  }
</div>
